import { settlementConstants } from '../constants/actionTypes'
import { FetchSettlementService } from '../services/settlementService'
import { ISettlementValue } from 'components/pages/ISettlementInputProps'

const settlementRequest = () => ({
  type: settlementConstants.FETCH_SETTLEMENT_REQUEST,
})

export const settlementSuccess = (data: any) => ({
  type: settlementConstants.FETCH_SETTLEMENT_SUCCESS,
  payload: data,
})

export const settlement = (opportunityId: string) => {
  return (dispatch: any) => {
    let settlementValue: ISettlementValue = {
      isValid: false,
      recipients: [],
    }

    dispatch(settlementRequest())
    return FetchSettlementService(opportunityId, null, null).then(
      (data: ISettlementValue) => {
        if (data == null) {
        } else {
          settlementValue = data
        }

        dispatch(settlementSuccess(settlementValue))
      },
      (error: string) => {
        console.error(`Error: ${error}`)
        dispatch(settlementSuccess(settlementValue))
      }
    )
  }
}
